// @flow
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import type { Resource } from 'esm-web-pro/containers/map/types';
import * as React from 'react';
import type { LatLng } from 'react-leaflet/lib/types';
import L from 'leaflet';
import { FormattedMessage } from 'react-intl';


type Props = {
    forwardedRef: Object,
    zoom: number,
    center: [number, number],
    setPosition: (center: LatLng, zoom: number) => {},
    setMapLoading: (mapLoading: boolean) => void,
    resources: Array<Resource>,
    bounds: Object,
    currentMap: Object,
    creator: React.ElementType,
    allowCreate: boolean,
}


class CoverageMapEditor extends React.Component<Props> {
    drawFeature = (result: Object, feature: Object, layer: Object, drawing: boolean, getFeatureTitle: Function) => {
        let tooltipContent;

        if (result.resource.tooltipContent) {
            // eslint-disable-next-line prefer-destructuring
            tooltipContent = result.resource.tooltipContent;
        } else {
            tooltipContent = getFeatureTitle(result.resource, feature);
        }

        if (typeof result.resource.additionalOptions === typeof Function) {
            layer.options = {
                ...layer.options,
                ...result.resource.additionalOptions(feature, layer),
            };
        }

        if (tooltipContent) {
            layer.bindTooltip(tooltipContent, { className: 'tooltip' });
        }
    };

    updateFeature = (result: Object, feature: Object, layer: Object, drawing: boolean) => {
        if (typeof result.resource.additionalOptions === typeof Function && !drawing) {
            const newStyle = {
                ...layer.options,
                ...result.resource.additionalOptions(feature),
            };

            if (newStyle.className && newStyle.className !== layer.options.className) {
                L.DomUtil.addClass(layer._path, newStyle.className);
            }

            switch (result.resource.type) {
            case 'point':
                layer.setIcon(newStyle.icon);
                break;
            default:
                layer.setStyle(newStyle);
            }
        }
    };

    render() {
        const {
            forwardedRef, zoom, center, setPosition, resources, bounds, setMapLoading,
            currentMap, creator, allowCreate,
        } = this.props;
        return (
            <BaseEditor
                ref={forwardedRef}
                zoom={zoom}
                center={center}
                setPosition={setPosition}
                setMapLoading={setMapLoading}
                resources={resources}
                bounds={bounds}
                currentMap={currentMap}
                drawFeature={this.drawFeature}
                creator={creator}
                allowCreate={allowCreate}
                updateFeature={this.updateFeature}
            >
                <h3>
                    <FormattedMessage
                        id="coverage.map-editor-title"
                        defaultMessage="Coverage"
                    />
                </h3>
            </BaseEditor>
        );
    }
}

export default CoverageMapEditor;
